import { makeStyles } from "@fluentui/react-components";
import { customTokens } from "../../../theme/theme";

const useHeaderStyles = makeStyles({
  header: {
    backgroundColor: customTokens.UNFCCCPrimaryOcean100,
    color: customTokens.colorNeutralForegroundInverted,
    transition: "all 0.3s ease",
  },

  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "0 auto",
    borderBottom: `1px solid ${customTokens.colorNeutralStrokeAlpha2}`,
    padding: "12px 120px",

    "@media (max-width: 1024px)": {
      padding: "12px 64px",
    },

    "@media (max-width: 768px)": {
      padding: "12px 20px",
    },
  },

  logoSection: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },

  logo: {
    height: "54px",
    width: "184px",
    cursor: "pointer",
  },

  divider: {
    height: "35px",
  },

  mobileLogo: {
    height: "35px",
    width: "118px",
    cursor: "pointer",
  },

  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: "24px",
  },

  unfcccLink: {
    cursor: "pointer",
    color: customTokens.colorNeutralForegroundInverted,
  },
});

export default useHeaderStyles;
